import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';

export function PrivacyPage() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <section className="pt-40 pb-20 px-4">
        <div className="max-w-2xl mx-auto">
          <motion.h1
            className="font-heading font-bold text-3xl mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Privacy Policy
          </motion.h1>
          <p className="text-content-secondary font-body leading-relaxed">
            Our privacy policy is being finalised and will be published before CogniPrint's public launch. CogniPrint is designed to comply with both POPIA (South Africa) and GDPR (Europe). For questions, contact{' '}
            <a href="mailto:legal@cogniprint.io" className="text-indigo-400 hover:text-indigo-300 transition-colors">
              legal@cogniprint.io
            </a>
            .
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
